
import axios from 'axios';

// Axios instance with default configuration
export const Api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
});


// Request interceptor to add Authorization token
Api.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // If Content-Type is not explicitly set, default to application/json
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

Api.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
